/** Indian mobile numbers, stored as "91XXXXXXXXXX". */
export function normalizeIndianPhone(input: string): string | null {
  let digits = input.replace(/[^\d]/g, '');
  if (digits.length === 12 && digits.startsWith('91')) digits = digits.slice(2);
  else if (digits.length === 11 && digits.startsWith('0')) digits = digits.slice(1);
  if (!/^[6-9]\d{9}$/.test(digits)) return null;
  return `91${digits}`;
}

/** "+91 98450 12345" */
export function formatPhone(normalized: string): string {
  const d = normalized.replace(/^91/, '');
  return `+91 ${d.slice(0, 5)} ${d.slice(5)}`;
}

/**
 * WhatsApp link with the message ready; staff only have to tap Send. Without a number, WhatsApp asks who to send it to.
 * Goes straight to api.whatsapp.com/send: the shorter wa.me link redirects there and, on the way, turns every emoji
 * (and other non-ASCII text such as ₹) into "�". The direct link keeps them on Android, iPhone, desktop and web.
 */
export function waLink(phone: string, text: string): string {
  return `https://api.whatsapp.com/send/?${phone ? `phone=${phone}&` : ''}text=${encodeURIComponent(text)}`;
}
